import { __assign } from 'tslib';
export const assign = __assign;
